import { Injectable, inject, EnvironmentInjector, runInInjectionContext } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {switchMap, tap} from 'rxjs/operators';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {Logger} from '../utils/logger';
import {FirebaseApi} from './firebase-api.service';
import {ConnectionStatus} from '../enums/connection-status.enum';

@Injectable({
  providedIn: 'root'
})
export class PresenceService {
  private afAuth = inject(AngularFireAuth);
  private firebaseApi = inject(FirebaseApi);
  private injector = inject(EnvironmentInjector);


  private readonly connectionSubject = new BehaviorSubject<ConnectionStatus>(ConnectionStatus.OFFLINE);

  constructor() {
    Logger.log(`PresenceService`);

    this.updateOnUser().subscribe();
    this.updateOnDisconnect().subscribe();
    // this.updateOnAway();
  }

  get observable(): Observable<ConnectionStatus> {
    return this.connectionSubject.asObservable();
  }

  private updateOnUser(): Observable<ConnectionStatus> {
    const connection = this.firebaseApi.presenceObservable;

    return this.afAuth.authState.pipe(
      switchMap(user => user ? connection : of(ConnectionStatus.OFFLINE)),
      tap(status => {
        Logger.log(`updateOnUser: ${status}`);
        return runInInjectionContext(this.injector, () =>
          this.firebaseApi.setPresence(status).then(() => {
            this.connectionSubject.next(status);
          })
        );
      })
    );
  }

  updateOnDisconnect() {
    return this.afAuth.authState.pipe(
      tap(user => {
        if (user) {
          const ref = runInInjectionContext(this.injector, () =>
            this.firebaseApi.getUserStatusRef(user.uid).query.ref
          );
          ref.onDisconnect()
            .update({
              status: ConnectionStatus.OFFLINE,
              timestamp: this.firebaseApi.timestamp
            });
        }
      })
    );
  }

  updateOnAway() {
    document.onvisibilitychange = (e) => {
      if (document.visibilityState === 'hidden') {
        runInInjectionContext(this.injector, () => this.firebaseApi.setPresence(ConnectionStatus.AWAY));
      } else {
        runInInjectionContext(this.injector, () => this.firebaseApi.setPresence(ConnectionStatus.ONLINE));
      }
    };
  }
}
